import * as approvalApi from "../api/approvalData";
import { notify } from "./notification";
import i18n from "i18next";
import * as _ from "lodash";
import formatEscape from "../utils/formatEscape";
import { batch } from "react-redux";
import { getCampaignDetail } from "./pendingApprovalCampaigns";
import { buildTestMessage } from "./campaign";

export const SET_APPROVAL_DATA = "SET_APPROVAL_DATA";
export const APPROVE_CAMPAIGN = "APPROVE_CAMPAIGN";
export const REJECT_CAMPAIGN = "REJECT_CAMPAIGN";

export function approveCampaign() {
  return async (dispatch, getState) => {
    const { params, approvalData } = getState();
    const { token } = params;
    const { _id: campaignId } = approvalData;

    const { message } = await approvalApi.approveOrRejectCampaign(
      campaignId,
      token,
      true
    );
    batch(() => {
      dispatch({ type: APPROVE_CAMPAIGN });
      // Show default message unless there is a message from backend
      dispatch(
        notify({
          type: "success",
          message: message
            ? i18n.t(message)
            : i18n.t("Successfully approved campaign"),
        })
      );
    });
  };
}

export function rejectCampaign(comment) {
  return async (dispatch, getState) => {
    const { params, approvalData } = getState();
    const { token } = params;
    const { _id: campaignId } = approvalData;
    const { message } = await approvalApi.approveOrRejectCampaign(
      campaignId,
      token,
      false,
      comment
    );
    batch(() => {
      dispatch(getCampaignDetail(campaignId));
      dispatch({ type: REJECT_CAMPAIGN });
      // Show default message unless there is a message from backend
      dispatch(
        notify({
          type: "success",
          message: message
            ? i18n.t(message)
            : i18n.t("Successfully rejected campaign"),
        })
      );
    });
  };
}

export function sendApprovalTest(
  addresses,
  templates = {},
  subjectFields = {},
  contentFields = {}
) {
  return async (dispatch, getState) => {
    const { params } = getState();
    const { token } = params;

    // Replace placeholders in templates if fields are provided
    let modifiedTemplates = { ...templates };

    if (!_.isEmpty(subjectFields) || !_.isEmpty(contentFields)) {
      const { emailTemplate = {}, smsTemplate = {} } = templates;
      const { subjectEmail = "", template: templateEmail = "" } = emailTemplate;
      const { template: templateSMS = "" } = smsTemplate;

      let tempSubject = subjectEmail;
      let tempContentEmail = templateEmail;
      let tempContentSMS = templateSMS;

      // Replace subject placeholders
      if (!_.isEmpty(subjectFields)) {
        for (let key in subjectFields) {
          if (subjectFields.hasOwnProperty(key)) {
            tempSubject = tempSubject.replace(
              new RegExp(`<%-\\s*${key}\\s*%>`, "g"),
              subjectFields[key]
            );
          }
        }
      }

      // Replace content placeholders
      if (!_.isEmpty(contentFields)) {
        for (let key in contentFields) {
          if (contentFields.hasOwnProperty(key)) {
            tempContentEmail = tempContentEmail.replace(
              new RegExp(`<%=\\s*${key}\\s*%>`, "g"),
              contentFields[key]
            );
            tempContentSMS = tempContentSMS.replace(
              new RegExp(`<%-\\s*${key}\\s*%>`, "g"),
              contentFields[key]
            );
          }
        }
      }

      modifiedTemplates = {
        ...templates,
        emailTemplate: {
          ...emailTemplate,
          template: tempContentEmail,
          subjectEmail: tempSubject,
        },
        smsTemplate: {
          ...smsTemplate,
          template: tempContentSMS,
        },
      };
    }

    const validatedAddresses = await Promise.all(
      addresses.map(async ({ type, value }) => {
        const testMessage = buildTestMessage(type, value, modifiedTemplates);

        try {
          await approvalApi.sendTestMessage(
            { channelType: type, data: testMessage },
            token
          );
          return { type, value };
        } catch (err) {
          return { type, value, error: true };
        }
      })
    );

    if (validatedAddresses.every((address) => address.error)) {
      dispatch(
        notify({
          type: "error",
          message: i18n.t("Failed to send test messages"),
        })
      );
    } else if (validatedAddresses.some((address) => address.error)) {
      dispatch(
        notify({
          type: "warning",
          message: i18n.t("Failed to send some test messages"),
        })
      );
    } else {
      dispatch(
        notify({
          type: "success",
          message: i18n.t("Successfully sent all test messages"),
        })
      );
    }

    return validatedAddresses;
  };
}
